import React from "react";
import List from "./List";
import FooterData from "./Footer.data";
import "./footer.css"
function Footer() {
	return (
		<React.Fragment>
			<footer className="footer">
				<div className="container-lg">
					<div className="footer-detail">
						<div className="top-box">
							<div className="leftbox">
								<div className="logo-location">
									<img src="/assets/images/logo.svg" />
									<p className="address">
										Robinson Road 0054, TYV Building, 068914 Singapore
									</p>
									<p className="mail-box">info@valuenable.com</p>
								</div>
								<div className="footer-list">
									{FooterData.map(function ShowCard(val, index) {
										return (
											<>
												<List
													key={index}
													ClassHead={val.ClassHead}
													Title={val.Title}
													Link={val.Link}
												/>
											</>
										);
									})}
									<div className="footer-data">
										<ul>
											<li className="maine-head">Useful Links</li>
											<li>
												<a href="#">Home</a>
											</li>
											<li>
												<a href="#">About Us</a>
											</li>
											<li>
												<a href="#">Privacy Policy</a>
											</li>
											<li>
												<a href="#">Terms & Conditions</a>
											</li>
										</ul>
										<ul className="footer-ul">
											<li className="maine-head">Our Services</li>
											<li>
												<a href="#">Web Design</a>
											</li>
											<li>
												<a href="#">Web Development</a>
											</li>
											<li>
												<a href="#">API Documentation</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="rightbox">
								<ul>
									<li className="maine-head">Get in touch</li>
									<li className="email-input">
										<div className="form-group">
											<input
												name="user"
												placeholder="Enter Your Email"
												type="text"
												className="form-control"
											/>
										</div>
									</li>
								</ul>
							</div>
						</div>
						<div className="copy-right">
							<p>Copyright ValuEnable © . All Rights Reserved</p>
						</div>
					</div>
				</div>
			</footer>
		</React.Fragment>
	);
}

export default Footer;
